@if (modalVisible()) {
<div class="fixed inset-0 flex justify-center items-center z-[9999] px-4 bg-[rgba(39,43,52,0.24)]"
  (click)="onBackdropClose()" (keydown.escape)="onBackdropClose()">
  <div class="{{
      modalService.customModalClasses() &&
      modalService.customModalClasses().trim() !== ''
        ? modalService.customModalClasses()
        : getModalClasses()
    }}" (click)="$event.stopPropagation()" (keydown.escape)="onBackdropClose()">
    <div class="flex flex-col items-center justify-center w-full">
      @if (modalService.useIcon()) {
      <div class="relative flex items-center justify-center mb-10">
        <div class="absolute rounded-full" [style.width.px]="getCircleSizes().outer"
          [style.height.px]="getCircleSizes().outer" [style.background-color]="getIconShadowColor()"></div>

        <i [ngClass]="[
            getIconClass(),
            getIconColor(),
            'relative z-10 flex items-center justify-center'
          ]" [style.width.px]="getIconSize()" [style.height.px]="getIconSize()" [style.line-height.px]="getIconSize()">
        </i>
      </div>
      } @else if (modalService.imageUrl()) {
      <div class="mb-6">
        <picture>
          <source [srcset]="modalService.imageUrl()" type=".webp" />
          <img [ngSrc]="modalService.imageUrl()" alt="Modal icon" class="w-48 h-42 object-cover" width="192"
            height="168" loading="lazy" />
        </picture>
      </div>
      } @if (modalService.showCloseIcon()) {
      <div class="flex items-center justify-between w-full mb-4">
        <h2 class="{{
            modalService.customTitleClasses() &&
            modalService.customTitleClasses().trim() !== ''
              ? modalService.customTitleClasses()
              : getTitleClasses()
          }} text-left m-0">
          {{ modalService.title() }}
        </h2>
        <button class="ml-2 text-xl text-neutrals-n100 hover:text-black-50" (click)="onClose()" aria-label="Cerrar">
          <i class="fi fi-ss-cross {{
              modalService.showCloseIconCustomClasses()
            }}"></i>
        </button>
      </div>
      } @else {
      <h2 class="{{
          modalService.customTitleClasses() &&
          modalService.customTitleClasses().trim() !== ''
            ? modalService.customTitleClasses()
            : getTitleClasses()
        }} mb-2">
        {{ modalService.title() }}
      </h2>
      } @if (modalService.message()) {
      <p class="w-full
          break-words {{
          modalService.customMessageClasses() &&
          modalService.customMessageClasses().trim() !== ''
            ? modalService.customMessageClasses()
            : getMessageClasses()
        }}" [innerHTML]="modalService.message()">
      </p>
      } @if (modalService.btnCancelar() || modalService.btnContinue()||
      modalService.btnMiddle()) {
      <div class="{{
          modalService.customButtonContainerClasses() &&
          modalService.customButtonContainerClasses().trim() !== ''
            ? modalService.customButtonContainerClasses()
            : 'flex flex-row w-full gap-4 pt-4 border-t border-secundary-b700 flex-wrap'
        }}" [ngClass]="{
          'mt-3':
            modalVariant !== 'legacy' &&
            (!modalService.customButtonContainerClasses() ||
              modalService.customButtonContainerClasses().trim() === '')
        }">
        @if (modalService.btnCancelar()) {
        <button class="{{
            modalService.customCancelButtonClasses() &&
            modalService.customCancelButtonClasses().trim() !== ''
              ? modalService.customCancelButtonClasses()
              : getButtonClasses('secondary')
          }}" (click)="onClose(true)">
          {{ modalService.cancelButtonText() || "Cancelar" }}
        </button>
        } @if(modalService.btnMiddle()){
        <button [ngClass]="
            modalService.customMiddleButtonClasses() &&
            modalService.customMiddleButtonClasses().trim() !== ''
              ? modalService.customMiddleButtonClasses()
              : getButtonClasses(
                  modalService.buttonTypeMiddle() === 'warning'
                    ? 'danger'
                    : 'primary'
                )
          " (click)="onConfirmMiddle()">
          {{ modalService.buttonTextMiddle() }}
        </button>
        } @if(modalService.btnContinue()){
        <button [ngClass]="
            modalService.customContinueButtonClasses() &&
            modalService.customContinueButtonClasses().trim() !== ''
              ? modalService.customContinueButtonClasses()
              : getButtonClasses(
                  modalService.modalType() === 'warning' ? 'danger' : 'primary'
                )
          " (click)="onConfirmClick()" [disabled]="!modalService.btnContinueIsEnabled()">
          {{ modalService.continueButtonText() || "Continuar" }}
        </button>
        }
      </div>
      }
    </div>

    <ng-content></ng-content>
  </div>
</div>
}